import type { FC } from "react";
import { useEffect } from "react";

import { Button, type IButton } from "@Components/Button";
import useAjax, { type IAjax } from "@Components/Hooks/useAjax";
import ImageLoader, { type IImageLoader } from "@Components/ImageLoader";
import { Loading } from "@Components/Loading";

import { TransitionButton } from "../common/Transition";
import LoyaltyDownloadPanel, { type ILoyaltyDownloadPanel } from "./LoyaltyDownloadPanel";

import * as css from "./LoyaltyCardInfo.module.css";

export enum LoyaltyCardInfoType {
    AlignRight,
    AlignBottom,
}

export interface LoyaltyCardInfoResult {
    cardImage: IImageLoader;
}

export interface ILoyaltyCardInfo extends IAjax<LoyaltyCardInfoResult> {
    title: string;
    aboutButton: IButton;
    loyaltyDownloadPanel: ILoyaltyDownloadPanel;
    loyaltyCardInfoType?: LoyaltyCardInfoType;
}

const LoyaltyCardInfo: FC<ILoyaltyCardInfo> = (
    props = {
        title: "",
        aboutButton: Button.defaultProps,
        loyaltyDownloadPanel: LoyaltyDownloadPanel.defaultProps as ILoyaltyDownloadPanel,
        loyaltyCardInfoType: LoyaltyCardInfoType.AlignRight,
    },
) => {
    const { data, isLoading, errorContainer, request } = useAjax(props);
    const cardImage = data && data.cardImage;

    useEffect(request, []);

    return (
        <div className={css.loyaltyCardInfoComponent}>
            <div className={css.cardInformation}>
                {props.title && <div className={css.title}> {props.title}</div>}
                <div className={css.details}>
                    <div className={css.image}>
                        {cardImage ? <ImageLoader {...cardImage} /> : isLoading && <Loading />}
                    </div>
                    {cardImage && (
                        <div className={css.aboutBenefitsButton}>
                            <TransitionButton {...props.aboutButton} />
                            {props.loyaltyDownloadPanel &&
                                LoyaltyCardInfoType.AlignRight === props.loyaltyCardInfoType &&
                                cardImage && <LoyaltyDownloadPanel {...props.loyaltyDownloadPanel} />}
                        </div>
                    )}
                </div>
            </div>
            {props.loyaltyDownloadPanel &&
                LoyaltyCardInfoType.AlignBottom === props.loyaltyCardInfoType &&
                cardImage && <LoyaltyDownloadPanel {...props.loyaltyDownloadPanel} />}
            {isLoading && <Loading isModal={true} />}
            {errorContainer}
        </div>
    );
};

export default LoyaltyCardInfo;
